import * as React from 'react';
import { Popconfirm } from 'antd';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { ROLE_TYPES } from '../../utils/DataConstants';
import {
	workOrdersRestCrudThunksForSupplier,
	workOrdersRestCrudThunksForBuyer,
	partiallyUpdateWorkOrder,
} from '../../thunks/work_orders_thunks';
import { withUserType } from '../withUserType';
import { getEntityById } from '../../utils/DataAccessUtils';
import { getSanitisedWorkOrder, getWorkOrderArchivalKey } from '../../utils/WorkOrderUtils';

function UnarchivePopConfirm({
	workOrder,
	isClientView = true,
	currentUser,
	userType,
	unarchiveWorkOrder,
	title = 'This work order is archived. Would you like to unarchive this work order to proceed?',
	onClick,
	onCancel,
	okText = 'Unarchive',
	cancelText = 'Cancel',
	placement = 'bottomLeft',
	disabled = false,
	buttonProps = {},
	children,
	...rest
}) {
	const sanitisedWO = getSanitisedWorkOrder(workOrder, isClientView);
	const isArchived = sanitisedWO[getWorkOrderArchivalKey(currentUser)];

	const handleConfirm = () => {
		return unarchiveWorkOrder(workOrder)
			.then(() => onClick && onClick())
			.catch((err) => console.error('Unarchive failed:', err));
	};

	if (isArchived) {
		return (
			<Popconfirm
				title={title}
				onConfirm={handleConfirm}
				onCancel={onCancel}
				okText={okText}
				cancelText={cancelText}
				placement={placement}
				disabled={disabled}
				{...rest}
			>
				{children}
			</Popconfirm>
		);
	}
	return React.cloneElement(children, {
		onClick: (e) => {
			e.stopPropagation();
			onClick && onClick(e);
		},
	});
}
const mapStateToProps = (state, ownProps) => ({
	workOrder: getEntityById(ownProps.match.params.id, state.work_orders),
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	unarchiveWorkOrder: (entity) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? workOrdersRestCrudThunksForSupplier.unarchive(entity, 'id', true)
				: workOrdersRestCrudThunksForBuyer.unarchive(entity, 'id', true)
		),
});

export default withRouter(
	withUserType(connect(mapStateToProps, mapDispatchToProps)(UnarchivePopConfirm))
);
